import React, { useState, useEffect } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import { SelectBox } from "devextreme-react/select-box";
import { TextBox } from "devextreme-react/text-box";
import { CheckBox } from "devextreme-react/check-box";
import { TextArea } from "devextreme-react/text-area";
import { FileUploader } from "devextreme-react/file-uploader";
import { Button } from "devextreme-react/button";
import QCP_API from "api/qcpApi";
import { Toast } from "devextreme-react/toast";
import { useNavigate, useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import {
  useDelete,
  useFetch,
  usePost,
  usePostFormData,
  useUpdate,
} from "@hooks/useQcpApi";
import { urlToFile } from "utils/helpers";
import "@common-components/cards/DarkCard.scss";
import { RadioGroup } from "devextreme-react";

export default function EditQCP({ id }) {
  const [isEdit, setIsEdit] = useState(true);

  const [selectedFiles, setSelectedFiles] = useState([]); // Store selected files
  const [uploadedFiles, setUploadedFiles] = useState([]); // Store uploaded file objects with statuses
  const [comments, setComments] = useState([]); // Store comments
  const [newComment, setNewComment] = useState(""); // Track input
  const [removedImages, setRemovedImages] = useState([]); // Track removed image identifiers

  const updateQCpMutation = useUpdate("updateqcp", QCP_API.addQcpData);
  const updateimageUploadMutation = usePostFormData(
    "uppdateImages",
    QCP_API.addImage
  ); // Use usePostFormData
  const updatecommentsMutation = useUpdate(
    "commentsupdate",
    QCP_API.addComment
  ); // Use usePostFormDgieata
  const deleteImageMutation = useDelete("dleetImage", QCP_API.addImage); // Use usePostFormDgieata
  const deleteFileMutation = useDelete("deletefiles", QCP_API.addFiles); // Use usePostFormData

  let userDetails = JSON.parse(localStorage.getItem("userDetails"));

  const imageUploadMutation = usePostFormData("uploadImages", QCP_API.addImage); // Use usePostFormData
  const fileUploadMutation = usePostFormData("uploadfiles", QCP_API.addFiles); // Use usePostFormData

  const {
    data: qcpEditData,
    loading: isqcpEditLoading,
    refetch: refetchQcpEditData,
  } = useFetch("getsingleQCP", QCP_API.addQcpData, { QCPId: id });
  const { data: qcpStatus, loading: isqcpStatusLoading } = useFetch(
    "getQCPStatus",
    QCP_API.getQCPStatus
  );

  const commentsMutation = usePost("commentsAdd", QCP_API.addComment); // Use usePostFormData

  const [visible, setVisible] = useState(false); // Default visible
  const [toastType, setToastType] = useState("error"); // Default error
  const [toastMessage, setToastMessage] = useState(""); // Default message
  const { data: approvedBY, loading: loadingApprove } = useFetch(
    "approvedbyget",
    QCP_API.approvedBy
  );
  const [loading, setLoading] = useState(false); // Add loading state

  const currentDate = new Date().toISOString(); // Store ISO format for consistency

  const showToast = (type, message) => {
    setToastType(type);
    setToastMessage(message);
    setVisible(true);
  };
  const handleAddComment = () => {
    if (newComment.trim() !== "") {
      const updatedComments = [
        ...comments,
        { commentID: Date.now(), commentText: newComment, commentedBy: userD },
      ];
      setComments(updatedComments);
      setNewComment("");
    }
  };
  const batchNum = localStorage.getItem("batchNum");
  let userD = JSON.parse(localStorage.getItem("userDetails"));
  console.log("userD", userD);

  const batchNumber = useSelector((state) => state.overview.batchNum);
  const batchId = useSelector((state) => state.overview.batchId);

  console.log("batchNumber", batchNumber);
  const navigate = useNavigate();
  const formik = useFormik({
    initialValues: {
      boxNo: "",
      batchNo: batchNumber,
      status: false,
      cleaning: false,
      pieces: null,
      grossKg: null,
      approvedBy: null,
      temperature: null,
      files: [],
      comments: [],
      documents: [],
      type: null, // Add testType to initialValues
      description: "",
      weight: "", // Add weight to initialValues
      smell: "", // Add smell to initialValues
      quantity: "", // Add quantity to initialValues
      labelInfo: "", // Add labelInfo to initialValues
      packaging: "", // Add packaging to initialValues
      quality: null,
    },
    validationSchema: Yup.object({
      batchNo: Yup.string().trim().required("Enter Batch Number"),
      boxNo: Yup.string().required("Enter Box Number"),
      quality: Yup.string().required("Select Product Quality"),
      approvedBy: Yup.string().required("Select Approved By"),
      status: Yup.string().required("Select Status"), // Corrected field name
      temperature: Yup.number()
        .nullable()
        .transform((value, originalValue) =>
          originalValue === "" ? null : value
        )
        .min(-20, "Temp should not be less than -20") // Minimum value validation
        .max(10, "Temp should not be greater than +10"), // Maximum value validation
    }),
    onSubmit: async (values) => {
      setLoading(true); // Start loading

      console.log("values", values, selectedFiles);
      let userD = JSON.parse(localStorage.getItem("userDetails"));
      console.log("userD", userD);

      try {
        if (isOtherSelected) {
          const isBoxNumberExists = boxNumbersData?.data?.some(
            (box) => box.boxNo === otherBoxNo
          );
          if (!isBoxNumberExists) {
            await handleOtherBoxNumber();
          }
          // Ensure "Other" box is added only if it doesn't exist
          // } else {
          //     showToast("error", "Box number already exists in the list");
          // }
        }

        const formValues = {
          ...values,
          comments: undefined, // Exclude comments
          files: undefined, // Exclude files
          inspectedBy: userD.firstName + " " + userD.lastName,
          approved: approvedBY ? true : false,
          boxNo: values.boxNo === "Other" ? otherBoxNo : values.boxNo,
          // pieces: Number(values.pieces), // Ensure pieces is a number
          // grossKg: Number(values.grossKg), // Ensure grossKg is a number
          temperature: values.temperature, // Ensure temperature is a number
          status: values.status,
        };

        // Always call updateQCpMutation
        await updateQCpMutation.mutateAsync({
          params: { QCPId: id }, // Send id as a query parameter
          data: formValues, // Send modified values
        });

        // Handle image deletions

        const originalImages = qcpEditData?.data[0]?.images || [];
        console.log("original Images", originalImages);
        const removedImages = originalImages.filter(
          (img) => !uploadedFiles.some((file) => file.id === img.imageID)
        );
        console.log("removedImages Images", removedImages);

        if (removedImages.length > 0) {
          for (const img of removedImages) {
            try {
              await deleteImageMutation.mutateAsync({ imageID: img.imageID });
            } catch (error) {
              console.error("Error deleting image:", error);
              showToast("error", "Failed to delete image");
            }
          }
        }
        console.log("selectedfiles", selectedFiles);
        console.log("uploadedFiles", uploadedFiles);
        // Handle new image uploads
        const newImages = selectedFiles?.filter((file) => {
          const isalreadyUploaded = !uploadedFiles?.some((data) => {
            const uploadedFileName = data.url.split(
              process.env.REACT_APP_API_BLOB_STORAGE_URL
            )[1];

            // return uploadedFileName.includes(file.name);
            return uploadedFileName === file.name;
          });
          return isalreadyUploaded;
        });
        console.log("newfiles", newImages);

        if (newImages.length > 0) {
          for (const file of newImages) {
            const formData = new FormData();
            formData.append("QCPId", id); // Attach qcp_id to each file
            formData.append("File", file); // Attach the file
            try {
              await imageUploadMutation.mutateAsync(formData);
              showToast("success", "Image uploaded successfully");
            } catch (error) {
              console.error("Error uploading image:", error);
              showToast("error", "Failed to upload image");
            }
          }
        }

        console.log("uploaded", uploadedAttachments);

        // Handle new attachment uploads
        console.log("selectedAttachmentsfiles", selectedAttachments);
        const originalAttachments = qcpEditData?.data[0]?.documents || [];
        const removedAttachments = originalAttachments.filter(
          (doc) =>
            !uploadedAttachments.some((file) => file.id === doc.documentID)
        );

        if (removedAttachments.length > 0) {
          for (const doc of removedAttachments) {
            try {
              await deleteFileMutation.mutateAsync({
                DocumentId: doc.documentID,
              });
            } catch (error) {
              console.error("Error deleting attachment:", error);
              showToast("error", "Failed to delete attachment");
            }
          }
        }

        console.log("selectedAttachmentsfiles", selectedAttachments);

        const newAttachments = selectedAttachments?.filter((file) => {
          const isAlreadyUploaded = !uploadedAttachments?.some((data) => {
            const uploadedFileName = data.url.split(
              process.env.REACT_APP_API_BLOB_STORAGE_URL
            )[1];
            return uploadedFileName === file.name;
          });
          return isAlreadyUploaded;
        });
        console.log("newAttachmentsfiles", newAttachments);
        if (newAttachments.length > 0) {
          for (const file of newAttachments) {
            const formData = new FormData();
            formData.append("QCPId", id); // Attach qcp_id to each file
            formData.append("File", file); // Attach the file
            try {
              await fileUploadMutation.mutateAsync(formData);
              showToast("success", "Attachment uploaded successfully");
            } catch (error) {
              console.error("Error uploading attachment:", error);
              showToast("error", "Failed to upload attachment");
            }
          }
        }

        // Handle attachment deletions

        // Handle comments
        const originalComments = qcpEditData?.data[0]?.comment || [];
        const removedComments = originalComments.filter(
          (comment) => !comments.some((c) => c.commentID === comment.commentID)
        );
        const newComments = comments.filter(
          (comment) =>
            !originalComments.some((c) => c.commentID === comment.commentID)
        );
        const editedComments = comments.filter((comment) => {
          const originalComment = originalComments.find(
            (c) => c.commentID === comment.commentID
          );
          return (
            originalComment &&
            originalComment.commentText !== comment.commentText
          );
        });

        const commentsPayload = {
          editQCPCommentsRequest: [
            ...removedComments.map((comment) => ({
              commentId: comment.commentID,
              qcP_ID: id,
              commentText: comment.commentText, // Keep the original text
              isDeleted: true,
              deletedDateUTC: new Date().toISOString(), // Add deleted date
            })),
            ...newComments.map((comment) => ({
              commentId: 0,
              qcP_ID: id,
              commentText: comment.commentText,
              isDeleted: false,
              deletedDateUTC: new Date().toISOString(), // Add deleted date
            })),
            ...editedComments.map((comment) => ({
              commentId: comment.commentID,
              qcP_ID: id,
              commentText: comment.commentText,
              isDeleted: false,
              deletedDateUTC: new Date().toISOString(), // Add deleted date
            })),
          ],
        };
        await updatecommentsMutation.mutateAsync({
          data: commentsPayload, // ✅ Send modified values
        });

        // Show success toast and stop loading after all operations
        showToast("success", "QCP updated successfully");
        setTimeout(() => {
          navigate("/quality/fillet/qcp");
          setLoading(false); // Stop loading
        }, 2000);
      } catch (error) {
        setLoading(false);
        console.error("Error submitting form:", error);
        showToast("error", "Failed to update QCP Inspect");
      }
    },
  });
  console.log("qcpEditData", qcpEditData);
  useEffect(() => {
    refetchQcpEditData(); // Explicitly refetch data when the component is mounted or id changes
  }, [id]);
  const getQCPImageFile = async () => {
    if (!qcpEditData?.data[0]?.images) return;

    const imagePromises = qcpEditData?.data[0]?.images.map(
      async (image) =>
        await urlToFile(image.imageURL, image.imageURL?.split("/").pop())
    );
    const attachmentsPromises = qcpEditData?.data[0]?.documents.map(
      async (doc) =>
        await urlToFile(doc.documentURL, doc.documentURL?.split("/").pop())
    );
    const apiFiles = await Promise.all(imagePromises);
    console.log(apiFiles);
    const apiAttachments = await Promise.all(attachmentsPromises);
    setSelectedFiles(apiFiles);
    setSelectedAttachments(apiAttachments);
  };
  useEffect(() => {
    if (qcpEditData) {
      formik.setValues({
        boxNo: qcpEditData?.data[0]?.boxNo,
        batchNo: qcpEditData?.data[0]?.batchNo,
        status: qcpEditData?.data[0]?.status.orderStatusId,
        cleaning: qcpEditData?.data[0]?.cleaning,
        quality: qcpEditData?.data[0]?.quality,
        approvedBy: qcpEditData?.data[0]?.approvedBy,
        temperature: qcpEditData?.data[0]?.temperature,
        files: qcpEditData?.data[0]?.images || [],
        documents: qcpEditData?.data[0]?.documents || [],
        comments: qcpEditData?.data[0]?.comment || [],
        weight: qcpEditData?.data[0]?.weight,
        smell: qcpEditData?.data[0]?.smell,
        quantity: qcpEditData?.data[0]?.quantity,
        labelInfo: qcpEditData?.data[0]?.labelInfo,
        packaging: qcpEditData?.data[0]?.packaging,
        description: qcpEditData?.data[0]?.description,
        type: qcpEditData?.data[0]?.type,
      });
      setComments(qcpEditData?.data[0]?.comment || []);
      setUploadedFiles(
        (qcpEditData?.data[0]?.images || []).map((image) => ({
          name: image.imageURL.split("/").pop(),
          url: image.imageURL,
          status: "uploaded",
          id: image.imageID,
        }))
      );
      setUploadedAttachments(
        (qcpEditData?.data[0]?.documents || []).map((doc) => ({
          name: doc.documentURL.split("/").pop(),
          url: doc.documentURL,
          status: "uploaded",
          id: doc.documentID,
        }))
      );
    }
    setBatchNo(qcpEditData?.data[0]?.batchNo);
    setBoxNo(qcpEditData?.data[0]?.batchNo);
    getQCPImageFile();
  }, [qcpEditData]);
  const handleFileChange = (e) => {
    const newFiles = e.value;

    // Filter out duplicates based on name and size
    const existingFilesMap = new Map(
      selectedFiles.map((file) => [`${file.name}-${file.size}`, file])
    );

    const uniqueNewFiles = newFiles.filter(
      (file) => !existingFilesMap.has(`${file.name}-${file.size}`)
    );

    const filePreviews = uniqueNewFiles.map((file) => ({
      name: file.name,
      size: file.size,
      url: URL.createObjectURL(file),
      status: "pending",
    }));

    setSelectedFiles([...selectedFiles, ...uniqueNewFiles]);
    setUploadedFiles([...uploadedFiles, ...filePreviews]);
  };
  const [fileUploaderKey, setFileUploaderKey] = useState(0);
  const handleDeleteImage = (identifier, index) => {
    setUploadedFiles((prev) =>
      prev.filter((file) => file.id !== identifier && file.url !== identifier)
    );

    setSelectedFiles((prev) => {
      const updated = prev.filter((_, i) => i !== index);
      setFileUploaderKey((k) => k + 1); // force FileUploader to re-render
      return updated;
    });
  };

  const [selectedAttachments, setSelectedAttachments] = useState([]); // Store selected attachments
  const [uploadedAttachments, setUploadedAttachments] = useState([]); // Store uploaded attachment objects with statuses
  const [attachmentUploaderKey, setAttachmentUploaderKey] = useState(0); // Key to force re-render of FileUploader

  const handleAttachmentsChange = (e) => {
    const newFiles = e.value;

    // Filter out duplicates based on name and size
    const existingFilesMap = new Map(
      selectedAttachments.map((file) => [`${file.name}-${file.size}`, file])
    );

    const uniqueNewFiles = newFiles.filter(
      (file) => !existingFilesMap.has(`${file.name}-${file.size}`)
    );

    const filePreviews = uniqueNewFiles.map((file) => ({
      name: file.name,
      size: file.size,
      url: URL.createObjectURL(file),
      status: "pending",
    }));

    // Update state only if there are new files to add
    // if (uniqueNewFiles.length > 0) {
    setSelectedAttachments((prev) => [...prev, ...uniqueNewFiles]);
    setUploadedAttachments((prev) => [...prev, ...filePreviews]);
    // }
  };

  const handleDeleteAttachment = (identifier, index) => {
    setUploadedAttachments((prev) =>
      prev.filter((attachment) => attachment.id !== identifier)
    );
    setSelectedAttachments((prev) => {
      const updated = prev.filter((_, i) => i !== index);
      setAttachmentUploaderKey((k) => k + 1); // Force FileUploader to re-render
      return updated;
    });
  };

  const handleDeleteComment = (commentID) => {
    setComments((prev) =>
      prev.filter((comment) => comment.commentID !== commentID)
    );
  };

  const boxMutation = usePost("BoxesAdd", QCP_API.addBoxes); // Use usePostFormData

  const [batchNo, setBatchNo] = useState(qcpEditData?.data[0]?.batchNo);
  const [boxNo, setBoxNo] = useState(null);

  const { data: boxNumbersData } = useFetch(
    batchNo ? "getBoxnumbers" : null,
    QCP_API.getBoxNumber,
    batchNo ? { batchNo, PageNo: 0, PageSize: 1000 } : undefined
  );

  const [isOtherSelected, setIsOtherSelected] = useState(false); // Track if "Other" is selected
  const [otherBoxNo, setOtherBoxNo] = useState(""); // Track input for "Other" box number

  const handleOtherBoxNumber = async () => {
    if (otherBoxNo.trim() !== "") {
      const payload = {
        boxNo: otherBoxNo,
        batchNo,
        // quality: formik.values.quality,
        // grossKg: formik.values.grossKg, // Use form values
        // pieces: formik.values.pieces,  // Use form values
        temperature: formik.values.temp, // Use form values
      };
      console.log("payload", payload);
      try {
        await new Promise((resolve, reject) => {
          boxMutation.mutate(payload, {
            onSuccess: () => {
              console.log("Box added successfully");
              setBoxNo(otherBoxNo); // Update boxNo state
              resolve();
            },
            onError: (error) => {
              console.error("Error adding box:", error);
              showToast("error", "Failed to add box");
              reject(error);
            },
          });
        });
      } catch (error) {
        console.error("Error in handleOtherBoxNumber:", error);
      }
    }
  };

  const { data: batchDataBox } = useFetch(
    boxNo ? "getBatchcboxdata" : null,
    QCP_API.getBoxData,
    boxNo ? { BoxShortNO: boxNo, BatchNo: batchNo } : undefined
  );

  console.log("batchDataBox", batchDataBox);
  if (isqcpEditLoading) {
    return <p>Loading...</p>; // Show a loading message while editData is being fetched
  }
  return (
    <>
      <Toast
        visible={visible}
        message={toastMessage}
        type={toastType} // success, error, warning, info
        displayTime={2000} // 3 seconds
        onHiding={() => setVisible(false)}
        position={{ my: "top right", at: "top right", offset: "10 10" }}
      />
      <div className="p-4 bg-gray-100 border rounded dark-bg">
        <div className="flex justify-end">
          <Button
            onClick={(e) => {
              if (e?.stopPropagation) e.stopPropagation(); // Safely prevent accordion toggle
              setIsEdit((prev) => !prev);
            }}
            // className="profile-edit-button"
            width={120}
            text={`${isEdit ? "Edit Record" : "View Record"}`} // Toggle text based on isEdit state
            stylingMode="contained"
            type="default"
          />
        </div>

        <div className="w-full flex items-center mt-3 lg:mt-0">
          {/* <p className="text-xl font-medium whitespace-break-spaces">Control Glass and Metal - Daily</p> */}

          <div className="flex-grow h-px bg-gray-300 ml-2 light-bg"></div>
        </div>
        <p>Check each box for overall quality, smell and label.</p>

        <form onSubmit={formik.handleSubmit}>
          {/* <p className='font-medium text-xl'>QMS Box Inspect Test</p> */}

          <div className="grid lg:grid-cols-2 grid-cols-1 gap-x-5 lg:space-y-0 space-y-3">
            <div className="border rounded border-gray-50 dark-bg p-4 custom-p-b-0">
              <div className="w-full flex items-center mb-2">
                <p className="whitespace-nowrap text-xl font-medium">
                  Add Info:
                </p>
                <div className="flex-grow h-[0.5px] bg-gray-300 light-bg ml-2"></div>
              </div>
              <div className="block lg:grid lg:grid-cols-2 space-y-4 lg:space-y-0 gap-4">
                <div>
                  <label className="text-sm mb-1 relative">
                    <span className="text-red-500 text-lg absolute top-[-4px] right-[-10px]">
                      *
                    </span>
                    Batch No.
                  </label>
                  <TextBox
                    disabled={isEdit}
                    placeholder="Enter Batch No..."
                    value={formik.values.batchNo}
                    onValueChange={(value) => {
                      formik.setFieldValue("batchNo", value); // Ensure formik state is updated
                      setBatchNo(value);
                      setBoxNo(null);
                      formik.setFieldValue("boxNo", null); // Reset box number when batch number changes
                    }}
                    isValid={!formik.errors.batchNo || !formik.touched.batchNo}
                    validationError={
                      formik.errors.batchNo
                        ? { message: formik.errors.batchNo }
                        : null
                    }
                  />
                </div>
                <div>
                  <label className="text-sm mb-1 relative">
                    <span className="text-red-500 text-lg absolute top-[-4px] right-[-10px]">
                      *
                    </span>
                    Box No.
                  </label>
                  <SelectBox
                    disabled={isEdit}
                    dataSource={[
                      ...(boxNumbersData?.data || []),
                      { boxNo: "Other" },
                    ]} // Add "Other" option
                    displayExpr="boxNo"
                    valueExpr="boxNo"
                    value={formik.values.boxNo}
                    onValueChanged={(e) => {
                      if (e.value === "Other") {
                        setIsOtherSelected(true); // Show input field for "Other"
                        formik.setFieldValue("boxNo", "Other"); // Set formik value to "Other"
                      } else {
                        setIsOtherSelected(false); // Hide input field for "Other"
                        formik.setFieldValue("boxNo", e.value);
                        setBoxNo(e.value);
                      }
                    }}
                    placeholder="Select a box number"
                    isValid={!formik.errors.boxNo || !formik.touched.boxNo}
                    validationError={
                      formik.errors.boxNo
                        ? { message: formik.errors.boxNo }
                        : null
                    }
                  />
                </div>
                {isOtherSelected && (
                  <div>
                    <label className="text-sm mb-1">Enter Box No.</label>
                    <TextBox
                      disabled={isEdit}
                      placeholder="Enter new box number..."
                      value={otherBoxNo}
                      // onFocusOut={(e) => handleOtherBoxNumber(e.value)} // Corrected syntax
                      onValueChanged={(e) => {
                        setOtherBoxNo(e.value); // Update state on change
                      }}
                    />
                  </div>
                )}
                {/* <div className="col-span-2">
                                <CheckBox text="Cleaning" value={formik.values.cleaning} onValueChanged={(e) => formik.setFieldValue("cleaning", e.value)} />
                            </div> */}
                <div>
                  <label className="text-sm mb-1 relative">
                    <span className="text-red-500 text-lg absolute top-[-4px] right-[-10px]">
                      *
                    </span>
                    Status
                  </label>
                  <SelectBox
                    disabled={isEdit}
                    dataSource={qcpStatus?.data || []}
                    displayExpr="description"
                    valueExpr="orderStatusId"
                    value={formik.values.status}
                    onValueChanged={(e) =>
                      formik.setFieldValue("status", e.value)
                    }
                    placeholder="Select a status"
                    isValid={!formik.errors.status || !formik.touched.status}
                    validationError={
                      formik.errors.status
                        ? { message: formik.errors.status }
                        : null
                    }
                  />
                </div>
                <div>
                  <label className="text-sm mb-1 relative">
                    <span className="text-red-500 text-lg absolute top-[-4px] right-[-10px]">
                      *
                    </span>
                    Performed by
                  </label>

                  <TextBox
                    disabled={true}
                    value={userDetails?.firstName + " " + userDetails?.lastName}
                    defaultValue={
                      userDetails?.firstName + " " + userDetails?.lastName
                    }
                    onValueChanged={(e) =>
                      formik.setFieldValue("inspectedBy", e.value)
                    }
                  // isValid={!(formik.errors.inspectedBy && formik.touched.inspectedBy)}
                  // validationError={formik.errors.inspectedBy ? { message: formik.errors.inspectedBy } : null}
                  />
                </div>
                <div>
                  <label className="text-sm mb-1 relative">
                    <span className="text-red-500 text-lg absolute top-[-4px] right-[-10px]">
                      *
                    </span>
                    Approved by
                  </label>
                  <SelectBox
                    disabled={isEdit}
                    dataSource={approvedBY?.data || []}
                    valueExpr="firstName"
                    displayExpr={(item) =>
                      item
                        ? item.firstName
                          .toLowerCase()
                          .split(" ")
                          .map(
                            (word) =>
                              word.charAt(0).toUpperCase() + word.slice(1)
                          )
                          .join(" ")
                        : ""
                    }
                    value={formik.values.approvedBy}
                    onValueChanged={(e) =>
                      formik.setFieldValue("approvedBy", e.value)
                    }
                    isValid={
                      !(formik.errors.approvedBy && formik.touched.approvedBy)
                    }
                    validationError={
                      formik.errors.approvedBy
                        ? { message: formik.errors.approvedBy }
                        : null
                    }
                    placeholder="Select an option"
                  />
                </div>
                <div>
                  <label className="text-sm mb-1 relative">
                    <span className="text-red-500 text-lg absolute top-[-4px] right-[-12px]">
                      *
                    </span>
                    Description
                  </label>

                  <div className=" w-full">
                    <TextBox
                      disabled={isEdit}
                      value={formik.values.description} // Use formik value or fallback to batchDataBox
                      placeholder="Enter description..."
                      width="100%"
                      onValueChanged={(e) =>
                        formik.setFieldValue("description", e.value)
                      } // Ensure decimal input
                      isValid={
                        !(
                          formik.errors.description &&
                          formik.touched.description
                        )
                      } // Show validation only if touched
                      validationError={
                        formik.errors.description
                          ? { message: formik.errors.description }
                          : null
                      }
                    />
                  </div>
                </div>
                <>
                  <div>
                    <label className="text-sm mb-1 relative">
                      <span className="text-red-500 text-lg absolute top-[-4px] right-[-12px]">
                        *
                      </span>
                      Quality
                    </label>
                    <RadioGroup
                      disabled={isEdit}
                      items={[
                        { id: true, text: "Ok" },
                        { id: false, text: "Not Ok" },
                      ]}
                      valueExpr="id"
                      displayExpr="text"
                      layout="horizontal"
                      value={formik.values.quality}
                      onValueChanged={(e) =>
                        formik.setFieldValue("quality", e.value)
                      }
                      isValid={
                        !(formik.errors.quality && formik.touched.quality)
                      }
                      validationError={
                        formik.errors.quality
                          ? { message: formik.errors.quality }
                          : null
                      }
                    />
                  </div>
                  <div>
                    <label className="text-sm mb-1 relative">
                      <span className="text-red-500 text-lg absolute top-[-4px] right-[-12px]">
                        *
                      </span>
                      Weight
                    </label>
                    <RadioGroup
                      disabled={isEdit}
                      items={[
                        { id: true, text: "Ok" },
                        { id: false, text: "Not Ok" },
                      ]}
                      valueExpr="id"
                      displayExpr="text"
                      layout="horizontal"
                      value={formik.values.weight}
                      onValueChanged={(e) =>
                        formik.setFieldValue("weight", e.value)
                      }
                      isValid={!(formik.errors.weight && formik.touched.weight)}
                      validationError={
                        formik.errors.weight
                          ? { message: formik.errors.weight }
                          : null
                      }
                    />
                  </div>
                  <div>
                    <label className="text-sm mb-1 relative">
                      <span className="text-red-500 text-lg absolute top-[-4px] right-[-12px]">
                        *
                      </span>
                      Smell
                    </label>
                    <RadioGroup
                      disabled={isEdit}
                      items={[
                        { id: true, text: "Ok" },
                        { id: false, text: "Not Ok" },
                      ]}
                      valueExpr="id"
                      displayExpr="text"
                      layout="horizontal"
                      value={formik.values.smell}
                      onValueChanged={(e) =>
                        formik.setFieldValue("smell", e.value)
                      }
                      isValid={!(formik.errors.smell && formik.touched.smell)}
                      validationError={
                        formik.errors.smell
                          ? { message: formik.errors.smell }
                          : null
                      }
                    />
                  </div>
                  <div>
                    <label className="text-sm mb-1 relative">
                      <span className="text-red-500 text-lg absolute top-[-4px] right-[-12px]">
                        *
                      </span>
                      Quantity
                    </label>
                    <RadioGroup
                      disabled={isEdit}
                      items={[
                        { id: true, text: "Ok" },
                        { id: false, text: "Not Ok" },
                      ]}
                      valueExpr="id"
                      displayExpr="text"
                      layout="horizontal"
                      value={formik.values.quantity}
                      onValueChanged={(e) =>
                        formik.setFieldValue("quantity", e.value)
                      }
                      isValid={
                        !(formik.errors.quantity && formik.touched.quantity)
                      }
                      validationError={
                        formik.errors.quantity
                          ? { message: formik.errors.quantity }
                          : null
                      }
                    />
                  </div>
                  <div>
                    <label className="text-sm mb-1 relative">
                      <span className="text-red-500 text-lg absolute top-[-4px] right-[-12px]">
                        *
                      </span>
                      Label Info
                    </label>
                    <RadioGroup
                      disabled={isEdit}
                      items={[
                        { id: true, text: "Ok" },
                        { id: false, text: "Not Ok" },
                      ]}
                      valueExpr="id"
                      displayExpr="text"
                      layout="horizontal"
                      value={formik.values.labelInfo}
                      onValueChanged={(e) =>
                        formik.setFieldValue("labelInfo", e.value)
                      }
                      isValid={
                        !(formik.errors.labelInfo && formik.touched.labelInfo)
                      }
                      validationError={
                        formik.errors.labelInfo
                          ? { message: formik.errors.labelInfo }
                          : null
                      }
                    />
                  </div>
                  <div>
                    <label className="text-sm mb-1 relative">
                      <span className="text-red-500 text-lg absolute top-[-4px] right-[-12px]">
                        *
                      </span>
                      Packaging
                    </label>
                    <RadioGroup
                      disabled={isEdit}
                      items={[
                        { id: true, text: "Ok" },
                        { id: false, text: "Not Ok" },
                      ]}
                      valueExpr="id"
                      displayExpr="text"
                      layout="horizontal"
                      value={formik.values.packaging}
                      onValueChanged={(e) =>
                        formik.setFieldValue("packaging", e.value)
                      }
                      isValid={
                        !(formik.errors.packaging && formik.touched.packaging)
                      }
                      validationError={
                        formik.errors.packaging
                          ? { message: formik.errors.packaging }
                          : null
                      }
                    />
                  </div>
                </>
                {/* <div>
                            <label className="text-sm mb-1 relative">
                                    <span className="text-red-500 text-lg absolute top-[-4px] right-[-10px]">*</span>Pieces
                                </label>
                                <TextBox
                                    value={formik.values.pieces ?? batchDataBox?.data?.pieces}
                                    placeholder="Enter Pieces..."
                                    onValueChanged={(e) => formik.setFieldValue("pieces", e.value)}
                                    isValid={!(formik.errors.pieces && formik.touched.pieces)}
                                    validationError={
                                        formik.errors.pieces && formik.touched.pieces
                                            ? { message: "Enter valid Pieces" }
                                            : null
                                    }
                                />
                            </div>
                            <div>
                            <label className="text-sm mb-1 relative">
                                    <span className="text-red-500 text-lg absolute top-[-4px] right-[-10px]">*</span>Gross (kg)
                                </label>
                               
                                <TextBox
                                    value={formik.values.grossKg ?? batchDataBox?.data?.grossKg}
                                    placeholder="Enter Gross kg..."
                                    onValueChanged={(e) => formik.setFieldValue("grossKg", e.value)}
                                    isValid={!(formik.errors.grossKg && formik.touched.grossKg)}
                                    validationError={
                                        formik.errors.grossKg && formik.touched.grossKg
                                            ? { message: "Enter valid Weight" }
                                            : null
                                    }
                                />
                            </div> */}
                <div>
                  <label className="text-sm mb-1 relative">
                    <span className="text-red-500 text-lg absolute top-[-4px] right-[-10px]">
                      *
                    </span>
                    Average Temp. (°C)
                  </label>

                  <TextBox
                    disabled={isEdit}
                    value={
                      formik.values.temperature ??
                      batchDataBox?.data?.temperature
                    }
                    placeholder="Enter temperature..."
                    onValueChanged={(e) =>
                      formik.setFieldValue("temperature", e.value)
                    }
                    isValid={
                      !(formik.errors.temperature && formik.touched.temperature)
                    }
                    validationError={
                      formik.errors.temperature && formik.touched.temperature
                        ? { message: "Enter a valid temperature" }
                        : null
                    }
                  />
                </div>
              </div>

              <div className="w-full flex items-center mt-4 mb-2">
                {
                  !isEdit ?
                    <p className="whitespace-nowrap text-xl font-medium">
                      Add Picture(s):
                    </p>
                    :
                    <p className="whitespace-nowrap text-xl font-medium">
                      Picture(s):
                    </p>
                }
              
                <div className="flex-grow h-px bg-gray-300 light-bg ml-2"></div>
              </div>
              {uploadedFiles.length > 0 || !isEdit ? (

              <div className="border-2 border-dashed hover:bg-gray-50 dark-bg rounded px-4 py-4 text-center">
                {!isEdit ? (
                  <FileUploader
                    multiple
                    accept=".png, .jpg, .jpeg, .jpg, .gif, .webp, .svg"
                    key={fileUploaderKey}
                    showFileList={false} // Hide the file list
                    onValueChanged={handleFileChange} // Triggered when files are selected
                  />
                ) : null}

                {uploadedFiles.length > 0 && (
                  <ul className="grid lg:grid-cols-3 grid-cols-1 gap-4 mb-0 ps-0">
                    {uploadedFiles.map((file, index) => (
                      <li key={index} className="text-sm relative">
                        <img
                          src={file.url}
                          alt={file.name}
                          className="w-full h-24 object-cover rounded border"
                        />
                        <p className="text-xs text-center mt-1 break-words mb-0">
                          {file.name}
                        </p>
                        {!isEdit ? (
                          <button
                            type="button"
                            className="absolute top-1 right-1 bg-red-600 text-white ml-10 text-xs rounded-full px-[7px] py-1"
                            onClick={() =>
                              handleDeleteImage(file.id || file.url, index)
                            }
                          >
                            ✕
                          </button>
                        ) : null}
                      </li>
                    ))}
                  </ul>
                )}
              </div>
  ) : (
  <div className="text-center text-red-800 p-8">
    No Data Found
  </div>
)}
              <div className="w-full flex items-center mt-4 mb-2">
                {
                  !isEdit ?
                    <p className="whitespace-nowrap text-xl font-medium">
                      Add Attachment(s):
                    </p>
                    :
                    <p className="whitespace-nowrap text-xl font-medium">
                      Attachment(s):
                    </p>
                }

                <div className="flex-grow h-px bg-gray-300 light-bg ml-2"></div>
              </div>
              {uploadedAttachments?.length > 0 || !isEdit ? ( 

                <div className="border-2 border-dashed hover:bg-gray-50 dark-bg rounded px-4 py-4 text-center">
                  {!isEdit ? (
                    <FileUploader
                      multiple
                      accept=".pdf, .docx, .xlsx .doc, .pptx, .txt, .ppt, .xls, .csv, .zip, .rar"
                      key={attachmentUploaderKey}
                      showFileList={false} // Hide the file list
                      onValueChanged={handleAttachmentsChange} // Triggered when files are selected
                    />
                  ) : null}
                  {uploadedAttachments.length > 0 && (
                    <ul className="space-y-2 ps-0 flex items-center justify-center flex-column mb-0">
                      {uploadedAttachments.map((file, index) => (
                        <li
                          key={index}
                          className="text-sm flex items-center space-x-2 rounded-md border p-2"
                        >
                          <span>{file.name}</span>
                          <button
                            type="button"
                            className="text-red-700 text-xs rounded-full p-1"
                            onClick={() =>
                              handleDeleteAttachment(file.id || file.url, index)
                            }
                          >
                            ✕
                          </button>
                        </li>
                      ))}
                    </ul>
                  )}
                </div>
              ) : (
                <div className="text-center text-red-800 p-8">
                  No Data Found
                </div>
              )}
            </div>
            <div className="border rounded border-gray-50 dark-bg p-4 flex flex-col">
              <div className="w-full flex items-center mb-2">
                <p className="whitespace-nowrap text-xl font-medium">
                  Add Comments:
                </p>
                <div className="flex-grow h-px bg-gray-300 light-bg ml-2"></div>
              </div>
              <div className="max-h-full flex-grow overflow-y-auto lg:pr-2 pr-0 custom-scrollbar space-y-2 mb-4">
                {comments?.map((comment, index) => (
                  <div
                    key={index}
                    className="bg-gray-100 hover:bg-gray-200 dark-bg hover:cursor-pointer rounded px-3 py-2 border"
                  >
                    <div className="flex items-center justify-between">
                      <p className="font-medium mb-0">
                        {comment?.commentedBy?.firstName +
                          " " +
                          comment?.commentedBy?.lastName}
                      </p>
                      <div className="flex items-center justify-end space-x-5">
                        <p className="text-xs mb-0 whitespace-nowrap mt-1">
                          {
                            new Date(comment.createdDateUTC || currentDate)
                              .toISOString()
                              .split("T")[0]
                          }{" "}
                          {/* Format date as yyyy-m-dd */}
                        </p>
                        {!isEdit ? (
                          <button
                            type="button"
                            className="text-red-700 ml-10 text-xs"
                            onClick={() =>
                              handleDeleteComment(comment.commentID)
                            }
                          >
                            ✕
                          </button>
                        ) : null}
                      </div>
                    </div>
                    <p className="flex-grow mt-2 break-words">
                      {comment.commentText}
                    </p>
                  </div>
                ))}
              </div>
              {!isEdit ? (
                <div className="mt-auto">
                  <TextArea
                    placeholder="Type comment..."
                    height={100}
                    maxLength={123}
                    stylingMode="outlined"
                    mode="multiline"
                    value={newComment} // Controlled input
                    onValueChanged={(e) => setNewComment(e.value)} // Only update newComment
                  />
                  <Button
                    className="mt-2"
                    icon="plus"
                    text="Add more comment"
                    stylingMode="text"
                    onClick={handleAddComment} // Call function on click
                  />
                </div>
              ) : null}
            </div>
          </div>

          {!isEdit ? (
            <div className="flex items-center justify-end mt-6">
              <Button
                onClick={() => {
                  navigate("/quality/fillet/qcp");
                }}
                className="me-3"
                width={100}
                text="Cancel"
                type="normal"
                stylingMode="outlined"
              />
              <Button
                text={loading ? "Saving..." : "Save"} // Change text when loading
                width={100}
                stylingMode="contained"
                type="default"
                disabled={loading}
                useSubmitBehavior
              />
            </div>
          ) : null}
        </form>
      </div>
    </>
  );
}
